import * as React from "react";
import {useEffect, useState} from "react";
import {ISubmissionProps} from "../utils/models";
import TotalPremises from "./TotalPremises";
import ColdRooms from "./ColdRooms";
import Vehicles from "./Vehicles";
import Equipment from "./Equipment";
import {getSurveySubmissions} from "../utils/submissions";
import Loader from "../../../shared/Loader";

const Infrastructure = ({container, selectedUoa, selectedYear, survey}: ISubmissionProps) => {
    const [loading, setLoading] = useState(true);
    const [submissions, setSubmissions] = useState([]);

    const getSurveysData = async () => {
        setLoading(true)

        if (survey) {
            const data = await getSurveySubmissions({container, survey_id: survey, selectedUoa, selectedYear})
            setSubmissions(data)
        }
    }

    useEffect(() => {
        getSurveysData().then(() => setLoading(false));
    }, [selectedUoa, selectedYear]);

    return (
        <>
            {
                !loading && (
                    <>
                        <div className="content-title col-span-2">
                            Infrastructure
                        </div>
                        <div className="space-y-4">
                            <TotalPremises submissions={submissions}/>
                            <ColdRooms submissions={submissions}/>
                            <Vehicles submissions={submissions}/>
                            <Equipment submissions={submissions}/>
                        </div>
                    </>
                )
            }
            {
                loading && (
                    <div className="loader-container col-span-2">
                        <Loader size={60}/>
                    </div>
                )
            }
        </>
    );
}

export default Infrastructure;